import { defineMessages } from 'react-intl';

export const bankAccountMessages = defineMessages({
    bankAccounts: {
        id: 'bank-accounts',
        defaultMessage: 'Bank accounts',
    },
    iban: {
        id: 'iban',
        defaultMessage: 'IBAN',
    },
    bic: {
        id: 'bic',
        defaultMessage: 'BIC',
    },
    createBankAccountSuccess: {
        id: 'create-bank-account-success',
        defaultMessage: 'Bank account created',
    },
    createBankAccountSuccessDescription: {
        id: 'create-bank-account-success-description',
        defaultMessage: 'The bank account has been successfully created.',
    },
    addBankAccountSubtitle: {
        id: 'add-bank-account-subtitle',
        defaultMessage: 'Create a new bank account',
    },
    deleteBankAccount: {
        id: 'delete-bank-account',
        defaultMessage: 'Delete bank account',
    },
    deleteBankAccountSuccess: {
        id: 'delete-bank-account-success',
        defaultMessage: 'Bank account deleted',
    },
    deleteBankAccountSuccessDescription: {
        id: 'delete-bank-account-success-description',
        defaultMessage: 'The bank account has been successfully deleted.',
    },
    confirmDeleteBankAccount: {
        id: 'confirm-delete-bank-account',
        defaultMessage: 'Are you sure you want to delete this bank account? This action cannot be undone.',
    },
    deleteBankAccountSubtitle: {
        id: 'delete-bank-account-subtitle',
        defaultMessage: 'Permanently delete bank account {entity}',
    },
    editBankAccountSubtitle: {
        id: 'edit-bank-account-subtitle',
        defaultMessage: 'Edit bank account {name}',
    },
    updateBankAccountSuccess: {
        id: 'update-bank-account-success',
        defaultMessage: 'The bank account was updated',
    },
    updateBankAccountSuccessDescription: {
        id: 'update-bank-account-success-description',
        defaultMessage: 'Bank account {name} has been successfully updated.',
    },
});
